import { useState, useEffect } from "react";

import BtnDataLogin from "components/BtnDataLogin";
import { Svg_Arrow, Svg_Logo, Svg_User } from "components/Svg";

import { GetUserData } from "interface/Users";
import { GetListPag, RegisterListPag, UnRegisterListPag } from "interface/Page";

import Page_Downloads from "pages/Downloads";
import Page_Shopkeepers_Profile from "pages/Shopkeepers/Profile";

export default function Contents_Shopkeepers(props){

    const [ currentPage, setCurrentPage ] = useState(GetListPag('currentPage'));

    const [ listOptDownload, setListOptDownload ] = useState([
        { "name": "Imagens", "page": "images" },
        { "name": "Catálogos", "page": "catalogs" },
        { "name": "Blocos 3D", "page": "3d_blocks" },
        { "name": "Manuais", "page": "manuals" },
        { "name": "Certificados", "page": "certificates" }
    ]);

    function CurrentPage(){
        switch (currentPage) {
            case "images":
                return <Page_Downloads type="none" origin="" name="Imagens" typePage="images" setLoading={ props.setLoading } />;
            case "catalogs":
                return <Page_Downloads type="none" origin="" name="Catálogos" typePage="catalogs" setLoading={ props.setLoading } />;
            case "3d_blocks":
                return <Page_Downloads type="none" origin="" name="3D Blocos" typePage="3D_blocks" setLoading={ props.setLoading } />;
            case "manuals":
                return <Page_Downloads type="none" origin="" name="Manuais" typePage="manuals" setLoading={ props.setLoading } />;
            case "certificates":
                return <Page_Downloads type="none" origin="" name="Certificados" typePage="certificates" setLoading={ props.setLoading } />;
        
            default:
                return <Page_Shopkeepers_Profile origin="" idPage={ GetUserData('idPage') } setLoading={ props.setLoading } />;
        }
    }

    useEffect(()=>{
        RegisterListPag('currentPage', setCurrentPage);
        return ()=>{
            UnRegisterListPag('currentPage', setCurrentPage);
        };
    }, []);

    return(
        <div className="Contents">
            <div className="div_menu">
                <div className="div_logo">
                    <Svg_Logo className="logo" color="#FFFFFF" />
                </div>

                <BtnDataLogin userFile={ props.userFile } userName={ props.userName } />
                
                <div className="opt_menu show_opt_menu">
                    <div className={ currentPage == "index" ? "name_menu menu_active" : "name_menu" } onClick={ ()=>{ props.CkickPage('index') } }>
                        Editar perfil
                    </div>
                    <div className="name_menu">
                        <div className="submenu">Downloads</div>
                        {
                            listOptDownload.map((elem, index)=>{
                                return(
                                    <div className={ currentPage == elem.page ? "submenu menu_active" : "submenu" } key={ index } onClick={ ()=>{ props.CkickPage(elem.page) } }>
                                        <Svg_Arrow className="icons" color="#ffffff" />
                                        { elem.name }
                                    </div>
                                )
                            })
                        }
                    </div>
                    <div className="name_menu exit" onClick={ ()=>{ props.Logout() } }>Sair</div>
                </div>
            </div>
            <div className="div_options">
                { CurrentPage() }
            </div>
        </div>        
    )
}